module.exports = __webpack_public_path__ + "static/img/预算内训.060c393.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/预算内训.jpg
// module id = Fdp8
// module chunks = 1